<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/wuxi/wx.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Wuxi Electronics Plant
                </div>
                <div class="manufacture-t2">
                    Located in Xishan Economic & Technological Development Zone, Wuxi, we dedicate to the R&D and innovation of Si IGBT and SiC MOS technologies with fully independent intellectual property rights. By integrating upstream and downstream resources, the company has built a complete industrial layout covering chip design and module packaging & testing.<br />
                    It operates a third-generation semiconductor R&D and manufacturing base in Wuxi and an application center in Baoding. The Wuxi base covers a floor area of approximately 30,000 ㎡, with an annual capacity of 1.2 million automotive-grade power modules.
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                IGBT Front-end
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Die Attach
                            </div>
                            <div class="destils">
                                It adopts industry-leading die attach systems with high placement accuracy and precisely controllable bonding pressure, enabling die attachment for IGBT/FRD wafers of various sizes.<br />
                                The ribbon cutting system achieves high-precision ribbon cutting.<br />
                                With a high degree of intelligence, it supports accurate chip traceability.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Die Bonding
                            </div>
                            <div class="destils">
                                It is supplied by Pink GmbH, Germany, a technology leader in the industry.<br />
                                This unique three-chamber vacuum soldering furnace features high vacuum level combined with formic acid, which effectively prevents material oxidation and activates bonding interfaces.<br />
                                It reduces void ratio in die bonding, lowers thermal resistance, and improves reliability and yield.<br />
                                Its process capabilities are comparable to Infineon, the industry benchmark.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Bonding
                            </div>
                            <div class="destils">
                                This heavy Cu/Al wire bonder is supplied by Germany’s Hesse, a global industry leader, supporting wire diameters from 100 to 600 μm.<br />
                                Adopting advanced high-power cold ultrasonic bonding, it delivers exceptional process stability.<br />
                                With 1ms process data sampling, real-time monitoring and charting are realized, clearly reflecting bonding stability and detecting anomalies.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                TC bonding
                            </div>
                            <div class="destils">
                                This latest-generation SiC die bonder from Panasonic Semiconductor Equipment (Japan) features an ultrasonic unit in the bonding head.<br />
                                Ultrasonic energy optimized via DOE is applied to the chip/silver paste interface, achieving rapid micro-bonding. It significantly boosts UPH with a 3-second CT per chip, only 20% of conventional bonders.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Sintering
                            </div>
                            <div class="destils">
                                Adopts cutting-edge silver sintering technology with independent pressing heads, ensuring high consistency of sintering strength among different chips on the same substrate.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-2.jpg" alt="">
                        </div>
                    </div>

                    
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                Post-Potting Process
            </div>
            
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                System Soldering Furnace
                            </div>
                            <div class="destils">
                                Provided by Germany’s PINK, a global industry leader, this unique four-chamber vacuum soldering furnace uses high vacuum and formic acid to prevent oxidation, activate interfaces, reduce voids and thermal resistance, and improve reliability and yield.<br />
                                Its process performance is comparable to Infineon, the industry benchmark.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Terminal Ultrasonic Welding
                            </div>
                            <div class="destils">
                                Supplied by Germany’s Schunk, an industry leader.<br />
                                It adopts the world’s most advanced standing-wave high-power ultrasonic terminal welding technology, reducing ceramic plate damage caused by welding pressure vs. traditional types, and improving product reliability and yield.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Final Test
                            </div>
                            <div class="destils">
                                Supplied by Italy’s SPEA, a leading test equipment supplier, it is specially designed for high-power module testing with excellent stability.<br />
                                It supports high/low temperature dynamic, normal temperature static, insulation and on-line RB aging tests for IGBT/SiC half-bridge/full-bridge modules, integrated with laser marking and automatic defective product rejection.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                Post-Molding Process
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Molding
                            </div>
                            <div class="destils">
                                Fully automatic molding equipment encapsulates products with molding compound via transfer molding, delivering reliable physical protection for power modules.<br />
                                It enables precise control of pressure and temperature, and is compatible with various epoxy molding compounds.<br />
                                Void and delamination control reaches an industry-leading level.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                HTXB
                            </div>
                            <div class="destils">
                                It features an ultra-wide temperature range, is compatible with HTRB and HTGB tests, and can accurately screen out early-stage chip-level failures of power modules.<br />
                                Adopting the industry’s most advanced hot-plate aging architecture, it improves efficiency by more than 20% compared with traditional oven-type aging equipment.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx3-2.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Wuxi Electronics Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/el/wuxi.html'
};

import { createApp } from 'vue';
import App from './wuxi.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./wuxi.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
